import { FormField } from 'ui/formField';
import { CheckboxField } from 'modules/templateEditor/common';
import { PushContentDefinition } from 'modules/graphql/types';

import { RestrictionBadge } from '../RestrictionBadge';
import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';
import { getIsEditMode } from '../../common/utils';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';

/*
  A component used to select the wake up option
  for Push templates.
*/
export const WakeUp = () => {
  const id = 'push-settings-check-wake-up';
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const readOnlyText = pushData.contentAvailable ? 'On' : 'Off';

  return (
    <FormField
      isHorizontalLayout
      labelText={SETTINGS_DISPLAY_CONTENT.wakeUp.labelText}
      restrictionText={<RestrictionBadge text={SETTINGS_DISPLAY_CONTENT.wakeUp.restriction} />}
    >
      {isEditModeVisible ? (
        <CheckboxField
          data-test={id}
          label={SETTINGS_DISPLAY_CONTENT.wakeUp.helpText}
          status={pushData.contentAvailable}
          onClick={() => setCurrentMediumField('contentAvailable', !pushData.contentAvailable)}
        />
      ) : (
        <SettingsReadOnlyText data-test="wake-up-on-off" isUnset={!pushData.contentAvailable}>
          {readOnlyText}
        </SettingsReadOnlyText>
      )}
    </FormField>
  );
};
